import { TwoFactorAuthSettingsMethod, TwoFactorAuthSettingsModel } from "./TwoFactorAuthSettingsModel";
import { AuthenticationMethodWizardViewModel } from "./AuthenticationMethodWizardViewModel";
import { NotificationService } from "../NotificationService";
import { ConfirmDialog } from "../ConfirmDialog";

export class TwoFactorAuthSettingsViewModel {
    constructor(options) {
        this.loadUrl = options.loadUrl;
        this.deleteUrl = options.deleteUrl;
        this.setMethodAsDefaultUrl = options.setMethodAsDefaultUrl;

        this.notificationService = new NotificationService();

        this.rootElement = options.$rootElement.get(0);
        this.wizardViewModel = options.wizardViewModel;
    }

    twoFactorAuthSettingsModel = new TwoFactorAuthSettingsModel();

    dataLoaded = ko.observable();

    hasAnyMethod = ko.computed({
        read: () => {
            return this.dataLoaded() && this.twoFactorAuthSettingsModel.methods().length > 0;
        }
    });

    hasDefaultMethod = ko.computed({
        read: () => {
            return this.dataLoaded() && this.twoFactorAuthSettingsModel.methods().some(x => x.isDefault);
        }
    });

    private readonly loadUrl: string;
    private readonly deleteUrl: string;
    private readonly setMethodAsDefaultUrl: string;

    private readonly rootElement: JQuery;
    private readonly notificationService: NotificationService;
    private readonly wizardViewModel: AuthenticationMethodWizardViewModel;

    init() {
        this.wizardViewModel.init();

        ko.applyBindings(this, this.rootElement);
        this.load();
    };

    load() {
        $.ajax({
            url: this.loadUrl,
            success: (data: any) => {
                if (data.success) {
                    const userMfaSettings = data.userMfaSettings;

                    this.twoFactorAuthSettingsModel.methods(
                        userMfaSettings.methods.map(x => {
                            const vm = new TwoFactorAuthSettingsMethod();
                            vm.id = x.id;
                            vm.methodType = x.methodType;
                            vm.methodTypeDescription = x.methodTypeDescription;
                            vm.name = x.name;
                            vm.isDefault = x.isDefault;
                            return vm;
                        })
                    );

                    this.dataLoaded(true);
                }
            }
        })
    }

    refresh() {
        this.load();
    }

    addNewMethod() {
        const callback = (data: any) => {
            if (data.success) {
                this.notificationService.showInfo(["New method successfully added"]);
            } else {
                this.notificationService.showError(data.message);
            }

            this.refresh();
        };

        this.wizardViewModel.addMethod(callback);
    }

    deleteMethod(method: TwoFactorAuthSettingsMethod) {
        if (method.isDefault) {
            this.notificationService.showError("Default method cannot be deleted");
            return;
        }

        ConfirmDialog({
            message: `Are you sure to delete method ${method.name}?`,
            title: 'Delete',
            callback: (result) => {
                if (result) {
                    $.ajax({
                        url: this.deleteUrl,
                        type: "POST",
                        data: { methodId: method.id },
                        success: (data: any) => {
                            if (data.success) {
                                this.notificationService.showInfo(["Method successfully deleted"]);
                            } else {
                                this.notificationService.showError(data.message);
                            }

                            this.refresh();
                        }
                    });
                }
            }
        });
    }

    setAsDefault(method: TwoFactorAuthSettingsMethod) {
        $.ajax({
            url: this.setMethodAsDefaultUrl,
            type: "POST",
            data: { methodId: method.id },
            success: (data: any) => {
                if (data.success) {
                    this.notificationService.showInfo(["Method successfully set to default"]);
                } else {
                    this.notificationService.showError(data.message);
                }

                this.refresh();
            }
        });
    }
}
